import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";

const BOOKING_URL = "https://booking.wellnessacademyusa.com/booking-page-wellness-academy";

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
  </svg>
);

const socialLinks = [
  { href: "https://www.instagram.com/wellnessacademyusa/", icon: InstagramIcon, label: "Instagram" },
  { href: "https://www.facebook.com/WellnessAcademyUSA", icon: FacebookIcon, label: "Facebook" },
  { href: "https://www.youtube.com/@WellnessAcademyUSA", icon: YouTubeIcon, label: "YouTube" },
  { href: "https://www.linkedin.com/company/wellnessacademyusa/", icon: LinkedInIcon, label: "LinkedIn" },
  { href: "https://maps.app.goo.gl/PiY1Rc6qhpJMrxLu7", icon: GoogleIcon, label: "Google" },
];

const Footer = () => {
  return (
    <footer className="bg-foreground text-background/80 relative overflow-hidden">
      {/* Center glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse at 50% 50%, rgba(217, 119, 6, 0.15) 0%, rgba(217, 119, 6, 0.05) 30%, transparent 70%)",
        }}
      />

      {/* Top CTA row */}
      <div className="border-b border-background/10 relative z-10">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-0">
          <a href="#programs" className="font-sans text-sm text-background/70 hover:text-nav-cta transition-colors duration-300 tracking-wide px-6">
            View Brochure
          </a>
          <span className="hidden sm:inline text-background/20">|</span>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="font-sans text-sm text-background/70 hover:text-nav-cta transition-colors duration-300 tracking-wide px-6">
            Book a Consultation
          </a>
          <span className="hidden sm:inline text-background/20">|</span>
          <Link to="/contact" className="font-sans text-sm text-background/70 hover:text-nav-cta transition-colors duration-300 tracking-wide px-6">
            Request a Quote
          </Link>
        </div>
      </div>

      {/* Centered logo above columns */}
      <div className="max-w-6xl mx-auto px-6 sm:px-8 pt-16 md:pt-20 relative z-10 text-center">
        <img src={logo} alt="Wellness Academy USA" className="h-16 w-auto mx-auto mb-10" />
      </div>

      {/* Main footer - 4 columns */}
      <div className="max-w-6xl mx-auto px-6 sm:px-8 pb-16 md:pb-20 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-10 mb-12">
          {/* Brand */}
          <div>
            <p className="font-sans text-sm font-light leading-relaxed text-background/60">
              Science-based cardiometabolic coaching and wellness retreats in San Diego & Miami. Restore metabolic health and extend your healthspan.
            </p>
          </div>

          {/* Programs */}
          <div>
            <p className="font-sans text-xs uppercase tracking-widest text-background/70 mb-4">Programs</p>
            <nav className="flex flex-col gap-2">
              <Link to="/nutrition" className="font-sans text-sm text-background/60 hover:text-nav-cta transition-colors duration-300">Nutrition & Culinary Wellness</Link>
              <Link to="/physical-activity-training" className="font-sans text-sm text-background/60 hover:text-nav-cta transition-colors duration-300">Physical Activity Training</Link>
              <Link to="/retreats" className="font-sans text-sm text-background/60 hover:text-nav-cta transition-colors duration-300">Luxury Wellness Retreats</Link>
            </nav>
          </div>

          {/* Company */}
          <div>
            <p className="font-sans text-xs uppercase tracking-widest text-background/70 mb-4">Company</p>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="font-sans text-sm text-background/60 hover:text-nav-cta transition-colors duration-300">Home</Link>
              <Link to="/about" className="font-sans text-sm text-background/60 hover:text-nav-cta transition-colors duration-300">About</Link>
              <Link to="/contact" className="font-sans text-sm text-background/60 hover:text-nav-cta transition-colors duration-300">Contact</Link>
            </nav>
          </div>

          {/* Connect */}
          <div>
            <p className="font-sans text-xs uppercase tracking-widest text-background/70 mb-4">Connect</p>
            <div className="space-y-2 mb-6">
              <a href="tel:+13104977904" className="block font-sans text-sm text-background/60 hover:text-nav-cta transition-colors duration-300">
                +1 310-497-7904
              </a>
              <span className="block font-sans text-sm text-background/60">San Diego, CA</span>
            </div>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full border border-background/30 flex items-center justify-center text-background/70 hover:text-nav-cta hover:border-nav-cta transition-colors duration-300"
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-background/10 pt-8">
          <p className="font-sans text-xs text-background/70 text-center">
            © {new Date().getFullYear()} Wellness Academy USA. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
